export default __webpack_public_path__ + "6f0cc12ed3d88e74a89fb4c9e37aadd0.png";